// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32HqE","col":"styles_col__2GLMS"};